import { useEffect, useState } from "react";
import { SingleSelect } from "../../../lib/iprs-react-library/src/index.js";
import { OKCancel } from "../../../lib/iprs-react-library/src/index.js";
import PersonSelect from "./PersonSelect";

const AppTypeAndPersonSelect = ({ appointmentTypes, clinician, appTypeGroups, onSelect, onCancel, api }) => {

    const [selectedAppointmentTypeID, setSelectedAppointmentTypeID] = useState(0);

    const [isVisual, setIsVisual]                               = useState(false);
    
    const [selectedUserID, setSelectedUserID]                   = useState(clinician);

    const handleClick = e => {
        e.preventDefault()

        if (selectedAppointmentTypeID || selectedUserID) {

            const selectedData = {
                AppointmentTypeID: selectedAppointmentTypeID,
                isVisual
            };
            if (selectedUserID) {
                selectedData.PartyID = selectedUserID;
            }

            onSelect(selectedData);
        }
    }

    return (<form>
        <AppTypeSelectSingle
            {...{
                appointmentTypes, appTypeGroups, selectedAppointmentTypeID,
                setSelectedAppointmentTypeID, api
            }} />

        <PersonSelect clinician={selectedUserID} setSelectedUserID={setSelectedUserID} api={api} 
            selectedAppointmentTypeID={selectedAppointmentTypeID} 
            isVisual={isVisual} setIsVisual={setIsVisual} />

        <OKCancel onOK={handleClick} onCancel={onCancel} enabled={selectedAppointmentTypeID} />
    </form>);
}

/* REACT component to display a select list of appointment types, with a button
 * to choose one.
 * calls onSelect with the selected object which includes title etc.
 * Note that the logic for using a group filter: First establish which group 
 * IDs are used in the app types then create a list of groups which have those IDs
 * so as to display a list of groups to filter on. If the group list contains less 
 * than 2 items then don't bother to display it. If the group list is displayed,
 * then the items in the app type select are filtered to just the selected group.
 * The label on the app type select differs depending whether it is preceeded by 
 * a group selector.
 */
const AppTypeSelectSingle = ({ appointmentTypes, appTypeGroups = [], 
    setSelectedAppointmentTypeID, selectedAppointmentTypeID}) => {

    const [selectedAppTypeGroup, setAGrp] = useState(0);

    useEffect(() => setSelectedAppointmentTypeID(0), [selectedAppTypeGroup, setSelectedAppointmentTypeID]);

    const groupIDsInUse = appointmentTypes.reduce((prev, curr) => [...prev, curr.GroupID], []);
    const groupsInUse = appTypeGroups.filter(g => groupIDsInUse.includes(g.GroupID));
    const displayGrps = groupsInUse?.length > 1;

    const groupSelect = (displayGrps && < div className='_wrapper' >
        <label>Group Filter</label>
        <SingleSelect
            selectableItems={[{ GroupID: 0, GroupTitle: 'All Groups' }, ...groupsInUse]}
            selectedItem={selectedAppTypeGroup}
            setSelectedItem={setAGrp}
            getItemID={g => g.GroupID}
            getItemTitle={g => g.GroupTitle} />
    </div>);

    const grpFilteredAppTypes = selectedAppTypeGroup ?
        appointmentTypes.filter(a => a.GroupID === selectedAppTypeGroup) :
        appointmentTypes;

    return <fieldset className='wrapcdper'>
        <legend>Select the Appointment Type</legend>
            {/*{displayGrps && <legend></legend>}*/}
            {groupSelect}
            <label htmlFor='selectAppType' >{displayGrps ? 'Appointment Type' : 'Select the Appointment Type'}</label>
            <SingleSelect
            selectableItems={[{ AppointmentTypeID: 0, Title: 'Select' }, ...grpFilteredAppTypes]}
            selectedItem={selectedAppointmentTypeID}
            setSelectedItem={setSelectedAppointmentTypeID}
            getItemID={a => a.AppointmentTypeID}
            getItemTitle={a => a.Title}
            name='selectAppType' />
    </fieldset>
}

export default AppTypeAndPersonSelect;